import script from "./LaneSuggessions.vue?vue&type=script&lang=ts&setup=true"
export * from "./LaneSuggessions.vue?vue&type=script&lang=ts&setup=true"

import "./LaneSuggessions.vue?vue&type=style&index=0&id=41fa3a58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41fa3a58"]])

export default __exports__